export default __webpack_public_path__ + "static/media/Padsoles of Black Whispers.7795d6c9.jpg";